export default {
  value: 0,

  init () {
    this.setValue()

    let timeout = null;
    window.addEventListener('resize', () => {
      if (timeout === null) {
        timeout = setTimeout(() => {
          this.setValue();
          timeout = null;
        }, 200);
      }
    })
  },

  setValue () {
    this.value = window.innerHeight * 0.01
    window.document.documentElement.style.setProperty('--vh', `${this.value}px`)
  }
}
